<template>
  <div>
    <el-upload
      :action=COMMON_CONFIG.IMG_UPLOAD_URL
      name="imgFile"
      list-type="picture-card"
      :multiple="false"
      :limit="1"
      :before-upload="beforeFileUpload"
      :on-success="handleImageSuccess"
      :on-remove="handleImgRemove0"
      :auto-upload="true"
      :file-list="fileList"
      :headers="imgHeaders"
      accept=".jpe,.jpeg,.png"
    >
      <i slot="default" class="el-icon-plus">
        <div style="font-size: 12px">仅支持png、jpeg、jpg</div>
      </i>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    defaultImgUrl: String,
  },
  inheritAttrs: false,
  data() {
    return {
      fileList: [],
      imgHeaders: {
        'X-Authorization-With': localStorage.getItem('token')
      }
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.fileList = [];
      if (this.defaultImgUrl != null && this.defaultImgUrl.length > 0) {
        this.fileList = [{
          name: this.defaultImgUrl,
          url: this.COMMON_CONFIG.LOAD_IMG_URL + this.defaultImgUrl,
        }];
      }
    },
    handleImageSuccess(res, file, list) {
      if (res.code == 0) {
        list.forEach(el => {
          el.name = res.data;
          // console.log(el);
        });
        this.handleImgChange(res.data);
      } else {
        this.$message.error(res.msg);
      }
    },
    async handleImgRemove0(file) {
      console.log(file);
      let filename = '';
      if (this.defaultImgUrl != null && this.defaultImgUrl.length > 0) {
        filename = this.defaultImgUrl;
      } else {
        filename = file.name;
      }
      const { data: res } = await this.$http.delete("file/img", {
        params: {
          fileName: filename,
        },
      });
      if (res.code == 0) {
        this.handleImgRemove();
      } else {
        this.$message.error(res.msg);
      }
    },
    handleImgChange(url) {
      this.$emit('imgOnChange', url)
    },
    handleImgRemove() {
      this.$emit('imgOnRemove')
    },
    beforeFileUpload(file) {
      const isLtM = file.size / 1024 / 1024 < 4;
      if (!isLtM) {
          this.$message.error('上传图片不能超过4MB!');
      }

      return isLtM;
    }
  },
};
</script>

<style lang="less" scoped>
</style>